import { ONBOARDING_ICP_AUDIENCE_NAME } from '~/components/Onboarding/constants';
import {
  useTargetMarketCompaniesQuery,
  useTargetMarketsQuery,
} from '~/generated/graphql';

import { CompanyType } from '../HomeCompanies/types';

function getMultipleRandomItems(
  array: Record<string, unknown>[] = [],
  items: number,
) {
  const shuffled = [...array].sort(() => 0.5 - Math.random());

  return shuffled.slice(0, items);
}

const DEFAULT_TARGET_MARKET_QUERY = {
  country: [],
  description: [],
  employees: [],
  industry: [],
  raised: [],
  tag: [],
  tech: [],
  type: [],
};

export const COMPANY_LIMIT = 12;

export const useHomeCompanies = () => {
  const {
    data: targetMarketsData,
    loading: loadingTargetMarkets,
  } = useTargetMarketsQuery();

  const mainICPSearch =
    !loadingTargetMarkets && targetMarketsData?.targetMarkets?.targetMarkets
      ? targetMarketsData?.targetMarkets?.targetMarkets.find(
          (targetMarket: any) =>
            targetMarket.name === ONBOARDING_ICP_AUDIENCE_NAME,
        )?.search
      : null;

  const hasTargetMarketDefinedIcp = !!mainICPSearch;

  const {
    data: targetMarketCompaniesData,
    loading: loadingTargetMarketCompanies,
  } = useTargetMarketCompaniesQuery({
    variables: {
      ...DEFAULT_TARGET_MARKET_QUERY,
      ...mainICPSearch,
    },
  });
  const isLoading = loadingTargetMarkets || loadingTargetMarketCompanies;

  const companies =
    !isLoading &&
    targetMarketCompaniesData?.targetMarketCompanies?.companies &&
    targetMarketCompaniesData?.targetMarketCompanies?.companies?.length
      ? getMultipleRandomItems(
          targetMarketCompaniesData?.targetMarketCompanies.companies,
          COMPANY_LIMIT,
        )
      : [];

  const companyCount = targetMarketCompaniesData?.targetMarketCompanies.total;

  const mainICPCompanies: CompanyType[] = !isLoading
    ? companies?.map((company: any) => {
        const companyTags = company?.tags;
        const employeeRange =
          company.employeesRange && `${company.employeesRange} employees`;

        const businessModelTag =
          companyTags &&
          companyTags?.length > 0 &&
          companyTags.find((tag: string) => tag.includes('B2'));

        return {
          name: company.name,
          domain: company.domain,
          tags: [
            company.country || 'Unknown country',
            company.industry || 'Unknown industry',
            employeeRange,
            businessModelTag,
            ...companyTags.slice(0, 3),
          ].filter(Boolean),
        };
      })
    : [];

  return {
    companyCount,
    hasTargetMarketDefinedIcp,
    isLoading,
    mainICPCompanies,
  };
};
